import React, { Component } from 'react';
import { View, Text, Link, Button, FilePicker, UploadList, TimeStamp, ActivityIndicator, Confirm, ASButton, WebBrowser } from 'core';
import { theme, css } from 'constants';
import { getUploadedFiles } from 'selectors';
import * as actions from 'actions';
import { IcoTrash, IcoSucess, IcoSubmit, IcoSubmits, IcoDoc, IcoDownload } from 'icons';
import { lang } from 'lang';

export class Submission extends Component {
    state = {};

    _submitTask = files => {
        const { task, conv_id } = this.props;
        files[0].file_id = task.id;
        actions.sendFiles({
            g_id: 'submissions',
            u_id: task.id,
            files,
            onSuccess: () => {
                this.setState({ submitting: true });
                actions.sendSubmission({ upload: getUploadedFiles({ g_id: 'submissions', u_id: task.id }), conv_id, task_id: task.id });
                actions.markUploadFinished({ g_id: 'submissions', u_id: task.id });
            }
        });
    };

    _removeSubmission = () => {
        const { submission, conv_id, task } = this.props;
        Confirm(lang.CONFIRMA_REMOVE_ITEM(submission.name), () => {
            actions.sendRemoveSubmissions({ conv_id, task_id: task.id });
            this.setState({ submitting: false });
        });
    };

    _renderFile = () => {
        const { submission } = this.props;
        let options = [
            { icon: IcoDoc, text: lang.VIEW, onPress: () => WebBrowser.show(submission) },
            { icon: IcoDownload, text: lang.DOWNLOAD, onPress: () => WebBrowser.download(submission) },
            { icon: IcoTrash, text: lang.DELETE, onPress: this._removeSubmission }
        ];
        return (
            <View style={styles.item}>
                <IcoSucess style={{ marginLeft: 5, color: theme.success_color }} />
                <View style={{ flex: 1, marginLeft: 5 }}>
                    <Text ellipsizeMode={'tail'} numberOfLines={1} style={{ color: theme.success_color, paddingBottom: 3 }}>
                        {lang.SUBMIT_MSG(submission.name)}
                    </Text>
                    <TimeStamp value={submission.created} style={styles.time} only_date_time />
                </View>
                <ASButton options={options} style={styles.as} />
            </View>
        );
    };

    _uploadBtn = () => (
        <Button style={styles.submission_btn} onPress={() => FilePicker.show({ asset_type: FilePicker.TYPES.ALL, multiple: true }, this._submitTask)}>
            <IcoSubmit size={30} color={theme.error_color_lighten(0.8)} />
            <Text style={{ marginLeft: 5, fontSize: theme.font_md, color: theme.gray_color_lighten(0.8) }}>{lang.SUBMIT}</Text>
        </Button>
    );
    _passedDeadline = () => (
        <View style={styles.passed_deadline}>
            <IcoSubmit size={30} color={theme.error_color_lighten(0.8)} />
            <Text style={{ marginLeft: 5, fontSize: theme.font_md, color: theme.gray_color_lighten(0.8), textDecorationLine: 'line-through' }}>{lang.SUBMIT}</Text>
        </View>
    );
    _submitCounter = () => {
        const { task, total_partic, conv_id, crossed_deadline } = this.props;
        return (
            <Link
                style={[styles.submission, crossed_deadline && { backgroundColor: theme.gray_color_lighten(0.2) }]}
                onPress={() => actions.clickViewSubmissions({ task_id: task.id, group_id: conv_id })}
            >
                <IcoSubmits size={30} color={theme.error_color_lighten(0.8)} />
                <Text style={styles.submit_counter}>{lang.SUBMISSION_COUNTER(task.total_submissions || '0', total_partic)}</Text>
            </Link>
        );
    };

    render() {
        const { upload, submission, crossed_deadline, is_admin } = this.props;
        let Comp;
        if (submission) {
            Comp = this._renderFile;
        } else if (this.state.submitting) {
            Comp = () => <ActivityIndicator />;
        } else if (upload) {
            Comp = () => <UploadList files={[upload]} style={styles.submission} />;
        } else if (is_admin) {
            Comp = this._submitCounter;
        } else if (crossed_deadline) {
            Comp = this._passedDeadline;
        } else {
            Comp = this._uploadBtn;
        }
        return <View style={[styles.submission, crossed_deadline && { backgroundColor: theme.gray_color_lighten(0.2) }]}>{Comp()}</View>;
    }
}
const styles = css({
    submission: {
        height: 60,
        backgroundColor: theme.error_color_lighten(0.2),
        justifyContent: 'center',
        paddingHorizontal: 10
    },
    submission_btn: {
        paddingLeft: 10,
        justifyContent: 'center',
        borderWidth: 0
    },
    passed_deadline: {
        flex: 1,
        flexDirection: 'row',
        alignItems: 'center',
        paddingLeft: 10
    },
    closed_submission: {
        height: 60,
        backgroundColor: theme.gray_color_lighten(0.2),
        paddingHorizontal: 20,
        justifyContent: 'center'
    },
    item: {
        marginVertical: 1,
        borderRadius: 10,
        flexDirection: 'row',
        alignItems: 'center'
    },
    text: {
        flex: 1,
        marginLeft: 10
    },
    submit_counter: {
        marginLeft: 5,
        fontSize: theme.font_md,
        color: theme.gray_color_lighten(0.8)
    },
    time: {
        fontSize: theme.font_sm,
        color: theme.success_color
    },
    as: {
        marginRight: -15
    }
});



// WEBPACK FOOTER //
// ./src/components/right/group_submission.js